export default 'LOCALES';
